/*
 * GT faceplate — product gallery full-screen viewer (PhotoSwipe v5, vendored).
 * Replaces Dawn's built-in zoom modal on the product template with a
 * swipeable / pinch-zoomable full-screen gallery. Pure add-on: it cancels
 * Dawn's <modal-opener> click in the capture phase and opens PhotoSwipe
 * instead, so no Dawn core file is touched. Reversible by removing the
 * {% render 'gt-product-lightbox' %} line in layout/theme.liquid.
 */
(function () {
  'use strict';

  if (typeof window.PhotoSwipeLightbox !== 'function' || typeof window.PhotoSwipe !== 'function') {
    return;
  }

  var FULL_WIDTH = 1946; // matches the largest width Dawn already renders

  function fullSrc(base) {
    if (!base) return base;
    if (/[?&]width=\d+/.test(base)) return base.replace(/([?&]width=)\d+/, '$1' + FULL_WIDTH);
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + FULL_WIDTH;
  }

  function buildSlides(list) {
    return Array.prototype.map.call(list.querySelectorAll('.product__media-item'), function (item) {
      var img = item.querySelector('.media img') || item.querySelector('img');
      var container = item.querySelector('.product-media-container') || item;
      var ratio = parseFloat(getComputedStyle(container).getPropertyValue('--ratio'));
      if (!ratio || !isFinite(ratio)) {
        ratio = (img && img.naturalWidth && img.naturalHeight) ? img.naturalWidth / img.naturalHeight : 1.5;
      }
      var base = img ? (img.currentSrc || img.getAttribute('src')) : '';
      return {
        src: fullSrc(base),
        msrc: base || undefined,
        width: FULL_WIDTH,
        height: Math.round(FULL_WIDTH / ratio),
        alt: img ? (img.getAttribute('alt') || '') : ''
      };
    });
  }

  function setup(root) {
    var gallery = root.querySelector('.product__media-wrapper');
    if (!gallery || gallery.dataset.gtPswp === '1') return;
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    gallery.dataset.gtPswp = '1';

    var lightbox = new window.PhotoSwipeLightbox({
      pswpModule: window.PhotoSwipe,
      bgOpacity: 0.9, // slightly see-through — the page stays faintly visible behind
      counter: true,
      zoom: true,
      loop: true,
      wheelToZoom: true,
      arrowKeys: true,
      // phone: use the whole screen. tablet / desktop: inset the stage so the
      // photo sits in a smaller centred area rather than edge-to-edge.
      paddingFn: function (viewportSize) {
        if (viewportSize.x < 750) return { top: 0, bottom: 0, left: 0, right: 0 };
        var padX = Math.round(viewportSize.x * 0.09);
        var padY = Math.round(viewportSize.y * 0.07);
        return { top: padY, bottom: padY, left: padX, right: padX };
      }
    });
    lightbox.init();

    list.addEventListener(
      'click',
      function (event) {
        var item = event.target.closest('.product__media-item');
        if (!item || !list.contains(item)) return;

        // only still images open in the viewer; leave video / 3d model alone
        var container = item.querySelector('.product-media-container');
        if (container && !container.classList.contains('media-type-image')) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
        var index = items.indexOf(item);
        if (index < 0) index = 0;
        lightbox.loadAndOpen(index, buildSlides(list));
      },
      true // capture: run before Dawn's <modal-opener> handler and swallow it
    );
  }

  function initAll() {
    document.querySelectorAll('#MainContent[data-template="product"]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // theme-editor re-render of the product section
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) setup(event.target);
  });
})();
